export default {
    path: "/personal",
    name: "Personal",
    meta: {
        title: "common.account.center",
    },
    component: () => import("../../views/UserCenter/index.vue"),
    children: [
        {
            path: "childuser",
            name: "ChildUser",
            meta: {
                title: "common.zzhgl",
            },
            component: () => import("../../views/UserCenter/ChildUser.vue"),
        },
        {
            path: "qbasic",
            name: "qbasic",
            meta: {
                title: "common.account.center",
            },
            component: () => import("../../views/UserCenter/Qbasic.vue"),
        },
        {
            path: "qinfo",
            name: "qinfo",
            meta: {
                title: "common.qyxx",
            },
            component: () => import("../../views/UserCenter/Qinfo.vue"),
        },
        {
            path: "basic",
            name: "Basic",
            meta: {
                title: "common.account.info",
            },
            component: () => import("../../views/UserCenter/Basic.vue"),
        },
        {
            path: "station",
            name: "Station",
            meta: {
                title: "common.team.station.detail",
            },
            component: () => import("../../views/UserCenter/Station.vue"),
        },
        {
            path: "order",
            name: "Order",
            meta: {
                title: "common.myorder",
            },
            component: () => import("../../views/UserCenter/Order.vue"),
        },
        {
            path: "invoice",
            name: "Invoice",
            meta: {
                title: "common.invoice.management",
            },
            component: () => import("../../views/UserCenter/Invoice.vue"),
        },
        {
            path: "security",
            name: "Security",
            meta: {
                title: "common.setting.security",
            },
            component: () => import("../../views/UserCenter/Security.vue"),
        },
        {
            path: "repairOrder",
            name: "RepairOrder",
            meta: {
                title: "common.cds42",
            },
            component: () => import("../../views/UserCenter/RepairOrder.vue"),
        },
        {
            path: "editInfo",
            name: "EditInfo",
            meta: {
                title: "common.bjgrxx",
            },
            component: () => import("../../views/UserCenter/EditInfo.vue"),
        },
        {
            path: "editQInfo",
            name: "EditQInfo",
            meta: {
                title: "common.as9",
            },
            component: () => import("../../views/UserCenter/EditQInfo.vue"),
        },
        {
            path: "setemail",
            name: "SetEmail",
            meta: {
                title: "common.emailbox.bind",
            },
            component: () => import("../../views/UserCenter/SetEmail.vue"),
        },
        {
            path: "setphone",
            name: "unBindPhone",
            meta: {
                title: "common.bind.phone",
            },
            component: () => import("../../views/UserCenter/SetPhone.vue"),
        },
        {
            path: "realName",
            name: "realName",
            meta: {
                title: "common.realname.certification",
            },
            component: () => import("../../views/UserCenter/RealName.vue"),
        },
        {
            path: "applyOpen",
            name: "ApplyOpen",
            meta: {
                title: "invoice.request",
            },
            component: () => import("../../views/UserCenter/ApplyOpen.vue"),
        },
        {
            path: "createdRepairOrder",
            name: "createdRepairOrder",
            meta: {
                title: "common.cds56",
            },
            component: () => import("../../views/UserCenter/CreatedRepairOrder.vue"),
        },
        {
            path: "buystorage",
            name: "BuyStorage",
            meta: {
                title: "common.ph13",
            },
            component: () => import("../../views/UserCenter/BuyStorage.vue"),
        },
        {
            path: "storeDetails",
            name: "StoreDetails",
            meta: {
                title: "common.ccxq",
            },
            component: () => import("../../views/UserCenter/StoreDetails/Index.vue"),
        },
        {
            path: "edmDetails",
            name: "EdmDetails",
            meta: {
                title: "common.edm.email.detail",
            },
            component: () => import("../../views/UserCenter/EdmDetails/index.vue"),
        },
        {
            path: "aiDetails",
            name: "AiDetails",
            meta: {
                title: "userinfo.vip.AI.detail",
            },
            component: () => import("../../views/UserCenter/AIDetails/index.vue"),
        },
        {
            path: "flowDetails",
            name: "FlowDetails",
            meta: {
                title: "common.ph29",
            },
            component: () => import("../../views/UserCenter/FlowDetails/Index.vue"),
        },
        {
            path: "repairOrderDetails",
            name: "RepairOrderDetails",
            meta: {
                title: "common.workorder.detail",
            },
            component: () => import("../../views/UserCenter/RepairOrderDetails.vue"),
        },
        {
            path: "orderDetails",
            name: "OrderDetails",
            meta: {
                title: "common.order.detail",
            },
            component: () => import("../../views/UserCenter/OrderDetails.vue"),
        },
        {
            path: "invoiceDetails",
            name: "InvoiceDetails",
            meta: {
                title: "common.cds73",
            },
            component: () => import("../../views/UserCenter/InvoiceDetails.vue"),
        },
        {
            path: "pay",
            name: "Pay",
            meta: {
                title: "common.pay",
            },
            component: () => import("../../views/UserCenter/Pay.vue"),
        },
        {
            path: "paySuccess",
            name: "PaySuccess",
            meta: {
                title: "common.payment.success",
            },
            component: () => import("../../views/UserCenter/Pay/PaySuccess.vue"),
        },
    ],
};
